const DEFAULT_FILENAME = 'export.csv';

const stepStripHtml = (state, ch) => {
  if (state.inTag) {
    return ch === '>' ? { out: state.out, inTag: false } : state;
  }
  if (ch === '<') {
    return { out: state.out, inTag: true };
  }
  return { out: state.out + ch, inTag: false };
};

/** Linear-time strip of simple `<...>` tags (avoids ReDoS-prone regex). */
const stripHtml = (value) => {
  const initial = { out: '', inTag: false };
  const final = Array.from(String(value)).reduce(stepStripHtml, initial);
  return final.out;
};

const normalizeCell = (value) => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return stripHtml(value);
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const escapeCsvCell = (raw) => {
  const value = normalizeCell(raw);
  const needsQuotes = /[",\n\r]/.test(value);
  const escaped = value.replaceAll('"', '""');
  return needsQuotes ? `"${escaped}"` : escaped;
};

const toCsv = (headers, rows) => {
  const headerLine = headers.map(escapeCsvCell).join(',');
  const lines = rows.map((row) => row.map(escapeCsvCell).join(','));
  return [headerLine, ...lines].join('\r\n');
};

const downloadTextFile = (filename, content, mimeType) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || DEFAULT_FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const downloadCsv = ({ filename, headers, rows }) => {
  const csv = toCsv(headers, rows);
  downloadTextFile(filename, csv, 'text/csv;charset=utf-8');
};

